var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-20"},[_c('timezone-form'),_c('student-bio'),_c('cards-list',{staticClass:"mx-10"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }